export default "dist/images/block-image-box-captioned.e4cb284.png";